import joi from 'joi';
import { CustomKeyTypes } from './profile';

export const customKeyPrefix = 'customKeys.';
export const customIdentityPrefix = 'identities.';
export const customReferralCodePrefix = 'referrals.';

export enum CustomKeyMode {
  FORCE = 'force',
  IMPORT = 'import',
}

export interface CustomKeyAttributes {
  id: string;
  accountId: string;
  name: string;
  technicalName: string;
  type: CustomKeyTypesEnum;
  deletedAt?: string;
  isNew?: boolean;
  fallbackValue?: CustomKeyTypes;
  mode?: CustomKeyMode;
}

export enum CustomKeyTypesEnum {
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  DATE = 'date',
  STRING = 'string',
}

export interface AddCustomKeyBody {
  id?: string;
  name: string;
  technicalName: string;
  type: CustomKeyTypesEnum;
  fallbackValue?: CustomKeyTypes;
  isNew?: boolean;
  mode: CustomKeyMode;
}

export const $addCustomKeyBody = joi.object<AddCustomKeyBody>({
  name: joi.string(),
  technicalName: joi.string(),
  type: joi.string().valid(...Object.values(CustomKeyTypesEnum)),
  mode: joi
    .string()
    .valid(...Object.values(CustomKeyMode))
    .optional()
    .default(CustomKeyMode.IMPORT),
  fallbackValue: joi
    .alternatives()
    .try(joi.string(), joi.number(), joi.boolean(), joi.date())
    .empty('')
    .allow(null)
    .optional()
    .default(null),
});
